<template >
   <div class="container-fluid" v-if="test!=null && category!=null">
 
     <div class="card shadow mb-4">
        
       <div class="card-header py-3">
         <div class="row">
           <div class="col-sm-12 col-md-6"><h3><span v-if="lesson">{{lesson.name}}/</span>{{test.name}}</h3></div>
           <div class="col-auto">
              <span class="fas fa-trash text-default mr-3" @click="empty"></span>
              <span v-if="showOnlyQuestions==true" class="fas fa-eye text-default mr-3" @click="onlyQuestion"></span>
              <span v-else="showOnlyQuestions==false" class="fas fa-eye-slash text-default mr-3" @click="onlyQuestion"></span>
              <span class="fas fa-trash text-default" @click="empty"></span>
            </div>
         </div>
        <h4>{{category.name}}</h4>
 
       </div>
       <div class="card-body">
        <ul v-if="asuultuud!=null && asuultuud.length>0">
          <button class="btn btn-sm btn-info my-3" @click="_saveAll">Бүгдийг хадгалах</button>
           <li v-for="(asuult, index) in asuultuud">
               <p> {{asuult.index}}, {{asuult.title}} [{{asuult.score}}] </p>
               <!-- <p style="color:red">{{asuult.description}}</p>
                -->
               <p style="color: blue">{{removeSolution(asuult.description)}}</p>
               <div v-if="showOnlyQuestions==true" style="margin-left:10px">
                 <span v-for="(answer, index) in asuult.answers">
                   <span v-if="answer.correct" style="color:green"> {{answer.name}}</span>
                   <span v-else="answer.correct" > {{answer.name}}</span>
                   <br/>
               </span>
               </div>
               <!-- <div style="margin-left:10px; border-style: dashed; padding: 20px 20px; background-color:#F2F3F5">
                 <span style="color: orange" v-for="(txt) in getSolution(asuult.description)">{{txt}}<br/></span>
               </div> -->
               <!-- <p style="color:red"> {{asuult.description}}</p> -->
                <button class="btn btn-sm btn-info my-3" @click="_save(asuult, index)"> хадгалах</button>
               <hr/>
           </li>
        </ul>
       </div>
   </div>
  <hr class="mb-5"/>
    
 
     <div class="card shadow mb-4">
        
       <div class="card-header py-3">
         <div class="row">
           <div class='col'>
             <h3>Асуулт нэмэх</h3>
           </div>

         </div>
       </div>
       <div class="card-body">
           <form class="user">
             <div>
               <!-- "<span  style="color:red">Оюутны код</span> &nbsp;&nbsp;<span style="color:blue">Регистр</span>" форматаар оруулна уу!!!.  Жишээ нь:
               <br/>
               D123456 УХ0000000<br/>
               D123457 БА99999999
               <br/> -->
               <div class="text-danger">Та дээрх форматнаас зөрүүлж оруулсан тохиолдолд асуулт буруу орно!!!</div>
             </div>
             <div class="form-group">
               <textarea rows="10" v-model.trim="studentsText" class="form-control" placeholder="Асуултуудын мэдээлэл"/>
             </div>
             <button type="button" class="btn btn-danger" @click="addBulkQuestions">
               Асуулт нэмэх
             </button>
 
             <hr>
            
           </form>
           
       </div>
 
     </div>
     <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
   </div>
  
</template>
 
<script>
const fb = require('../../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
 
 
export default {
   name: "IQuestionAddBulk",
 
   data() {
       return {
           lesson: null,
          test:null,
          category:null,
           types:[],
           studentsText:'',
           selectedTopic:null,
           tmpStudents:[],
           students:[],
 
           lessonBucket:'lessonFiles/',
           topicBucket:'lessonTopicFiles/',
           asuultuud: [],
           loading:false,
           showOnlyQuestions: true
          
       };
   },
   methods: {
      
     _getQA(){
 
         fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).onSnapshot(doc=> {
             let lesson=doc.data();
             lesson.id=doc.id
             this.lesson=lesson;
          
         });
 
         fb.db.doc(this.detailPath).onSnapshot(testDoc=> {
           if(testDoc.exists){
             this.test=testDoc.data();
             testDoc.ref.collection("tests").doc(this.categoryId).get().then((cdoc)=>{
               this.category=cdoc.data();
             });
           }

          
         });
 
 
 
     },
     removeSolution(description){
       var text = '';
       var found = false;
       for(var i=0; i < description.length; i++){
         if( description[i]=='Даалгаврын шинжилгээ') 
           found = true;
         if(!found)
           text = text + description[i] + '\n';
       }
       return text;
     },
     getSolution(description){
       var texts = [];
       var found = false;
       for(var i=0; i < description.length; i++){
         if(description[i]=='Даалгаврын шинжилгээ') 
           found = true;
         if(found)
             texts.push(description[i]);
        
       }
       return texts;
     },
     isContained(value){
       for(var i=0; i< 100; i++){
          if(value.trim().startsWith(i+'.')) {
            return true;
          }
       }
       return false;
     },
     empty(){
       this.asuultuud = [];
     },
     onlyQuestion(){
       this.showOnlyQuestions= !this.showOnlyQuestions;
     },
     removeSimpleItemText(str){
       var index = str.indexOf('.');
   
       if(index>=0)
        return str.substring(index+1, str.length).trim();
       else return str;
     },
     removeScoreText(str){
      var scoreIndex = str.indexOf('оноо');
      var firstIndex =-1;
      var endIndex =-1;

      if(scoreIndex>0){
        for(var i=scoreIndex; i<str.length;i++){
          if(str[i]==')')
            endIndex = i;
        }
        for(var i=scoreIndex; i>=0;i--){
          if(str[i]=='(')
            firstIndex = i;
        }
        if(firstIndex>0&& endIndex>0&&firstIndex<endIndex) 
          return str.replace(str.substring(firstIndex+1, endIndex).trim(),'').replace('()','').replace('\\hfill','').trim();
        return str;
    
      } else
          return str;
 

     },
     extractTextBetween(str){
      var scoreIndex = str.indexOf('оноо');
      var firstIndex =-1;
      var endIndex =-1;

      if(scoreIndex>0){
        for(var i=scoreIndex; i<str.length;i++){
          if(str[i]==')')
            endIndex = i;
        }
        for(var i=scoreIndex; i>=0;i--){
          if(str[i]=='(')
            firstIndex = i;
        }
      }
      if(firstIndex>0&& endIndex>0&&firstIndex<endIndex) 
        return str.substring(firstIndex+1, scoreIndex).trim();
      return null;

     },
     extractItemIndex(str){
       var index = str.indexOf('\\item[');
       var firstIndex =-1;
       var lastIndex =-1;

       for(var i=index; i<str.length;i++){
         if(str[i]=='[')
          firstIndex = i;
         else if (str[i]==']') {
           lastIndex = i;
           break;
         }
       }
       if(firstIndex>0&& lastIndex>0&&firstIndex<lastIndex) 
        return str.substring(firstIndex+1, lastIndex);
       else return null;
     },
       extractSimpleItemIndex(str){
       var strr = str.split('.');
       if(strr.length>0)
        return strr[0];
       else return 'N/A'
      
     },
     addBulkQuestions(){
       var currentQuestion;
 
       if(this.studentsText!=null && this.studentsText!=''){
 
         var arrayOfLines = this.studentsText.match(/[^\r\n]+/g);
         this.tmpStudents=[];
         var asuultFound = false;
         if(arrayOfLines!=null && arrayOfLines.length>0){
           arrayOfLines.forEach(value=>{

               if(this.isContained(value)){
                 var tmpTitle = this.removeSimpleItemText(value.trim());
                 tmpTitle = this.removeScoreText(tmpTitle);
                 tmpTitle = tmpTitle.replace(new RegExp("\t", 'g'), "");

                 currentQuestion = {
                  index:Number(this.extractSimpleItemIndex(value.trim()).trim()), 
                  title: [tmpTitle.trim()], 
                  description:[], 
                  answers:[],
                  score: Number(this.extractTextBetween(value.trim()))
                 };
                  
                  this.asuultuud.push(currentQuestion);
               }
               else if(value.startsWith('\\item[')) {
                 var tmpTitle = this.removeSimpleItemText(value.trim());
                 tmpTitle = this.removeScoreText(tmpTitle);
                 currentQuestion = {
                  index:Number(this.extractItemIndex(value.trim()).replace('.','').trim()), 
                  title: [tmpTitle.trim()], 
                  description:[], 
                  answers:[],
                  score: Number(this.extractTextBetween(value.trim()))
                 };
                  
                  this.asuultuud.push(currentQuestion);
  
               } 
               
               else if(
                 value.trim().startsWith('A.') ||
                 value.trim().startsWith('B.') ||
                 value.trim().startsWith('C.') ||
                 value.trim().startsWith('D.') ||
                 value.trim().startsWith('E.') ||
                 value.trim().startsWith('F.')
              
               ){
                 console.log(value+"_"+value.trim().indexOf('\\qquad'))
                 if(value.trim().indexOf('\\qquad')!=-1){
                  //  console.log("1");
                  //  console.log("_______________________");
                   var answers = value.trim().split('\\qquad');
                   answers.map(el => {
                     currentQuestion.answers.push({name:el.trim(), correct:false}); 
                   }); 
                 }
                 else{
                  //  console.log("2");
                  //  console.log("_______________________");
                   if(value.trim().endsWith('**'))
                    currentQuestion.answers.push({name:value.trim().replace("**", ''), correct:true}); 
                   else
                    currentQuestion.answers.push({name:value.trim(), correct:false}); 
                   }
                 //console.log(value);
               } 
               else {
                  currentQuestion.title.push(value.trim()); 
               }
           });
           this.studentsText='';
         }
       }
     },
   

     checkModalShow(){
       if(this.tmpStudents.length==0)
         $('.bd-example-modal-lg').modal('hide');
     },
  
     setProperty(propertyName, object, value){
       if(object!=null && propertyName!=null){
         var tmp={};
         tmp[propertyName]=value;
         object.update(tmp);
       }
     },
     validFile(file){
       if(file.fileName.endsWith("mp4")
           || file.fileName.endsWith("MP4")
           || file.fileName.endsWith("MPEG")
           || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
           || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
         ){
           return false;
       }
       return true;
     },
     makeString(list){
       var str='';
       for(var i=0; i<list.length;i++){
         if(i==0) str = list[i];
         else str = str + '. ' + list[i];
       }
       return str.trim();
     },
    async _save(data, index, remove) {
       
        if(data!=null && data!=undefined){

          var batch = fb.db.batch();      
          this.loading=true;
          var tmpQuestion = Object.assign({}, data);
          delete tmpQuestion.answers;
          delete tmpQuestion.description;
          tmpQuestion.createdAt=new Date();
          tmpQuestion.simple=true;
          tmpQuestion.title= this.makeString(tmpQuestion.title);
          var questionRef=fb.db.doc(this.detailPath).collection("tests").doc(this.categoryId).collection("questions").doc();
          // await questionRef.set(tmpQuestion);
          batch.set(questionRef, tmpQuestion);

          var subquestionRef=questionRef.collection("subquestions").doc();
          // await subquestionRef.set({
          //   index:0,
          //   title: this.makeString(tmpQuestion.title),
          //   answertype:false,
          //   multichoice:false,
          //   score:(tmpQuestion.score=null||isNaN(tmpQuestion.score))?0:tmpQuestion.score, 
          // });
          var subquestionObject={
              index:0,
              title: tmpQuestion.title,
              description: tmpQuestion.description!=undefined? tmpQuestion.description:null,
              answertype:false,
              multichoice:false,
              score:(tmpQuestion.score==undefined)?0:tmpQuestion.score, 
            };
          batch.set(
            subquestionRef,
            subquestionObject
          );

          if(data.answers!=null && data.answers.length>0){
            var i=0;
            for (const answer of data.answers) {
              var tmpAnswer= Object.assign({}, answer);
              tmpAnswer.index=i;
              tmpAnswer.votedCount=0;
              tmpAnswer.createdAt=new Date();

              var answerRef= subquestionRef.collection("answers").doc();
              // await answerRef.set(tmpAnswer);
              batch.set(answerRef, tmpAnswer);

              i++;
            }
          }

          
          await batch.commit();
          this.loading=false;
        }
        if(remove!=null && remove==true)
          this.asuultuud.splice(index,1);

      },
      async _saveAll() {
        
        if(this.asuultuud!=null && this.asuultuud.length>0){
          var r = confirm("Бүгдийг хадгалах уу. Та хадгалагдаж дуустал вэбээс гаралгүй хүлээнэ үү");
          if (r == true) {
            var i=0;
            for(const value of this.asuultuud){
              await this._save(value, i, false);

            }
            this.asuultuud=[];
            alert("Амжилттай хадгаллаа");
          } 
        }

      },
   },
   computed: {
       ...mapState(['userProfile', 'currentUser'])
   },
   props: {
    schoolId:{
      required:true
    },
       lessonId: {
           required: false,
       },
       detailPath:{
         required:true
       },
       categoryId:{
         required:true
       }
   },
   created() {
       var _this=this;
       if(this.detailPath!=null && this.detailPath!='' && this.categoryId!=null && this.categoryId!='')
         this._getQA();
          
   },
   filters: {
 	 formatDate(val) {
       if(val!=null){
         if (!val) { return '-' }
         let date = val.toDate()
         return moment(date).fromNow()
       }
       return '-'
     },
  
   }
 };
</script>
 

